module.exports = __webpack_public_path__ + "img/Banner-Page.bd184290.jpg";